import { render, staticRenderFns } from "./ProjectOkpdProducts.vue?vue&type=template&id=3d660bee&scoped=true"
import script from "./ProjectOkpdProducts.vue?vue&type=script&lang=js"
export * from "./ProjectOkpdProducts.vue?vue&type=script&lang=js"
import style0 from "./ProjectOkpdProducts.vue?vue&type=style&index=0&id=3d660bee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d660bee",
  null
  
)

export default component.exports